// A FIFO queue that runs one task per browser idle turn (falling back to a macrotask when
// requestIdleCallback isn't available). Used to spread a burst of synchronous, CPU-heavy work —
// e.g. many editors becoming eligible to initialize at the same time — across separate turns
// instead of running it all back-to-back in one frame, which is what actually freezes the tab.
// A concurrency *count* wouldn't help here: each task is fully synchronous, so the only way to
// spread the cost over time is to serialize execution across turns, not to limit parallelism.
export function createIdleTaskQueue({ timeout = 500 } = {}) {
  const queue = []
  let draining = false

  function schedule(callback) {
    if (typeof globalThis.requestIdleCallback === 'function') {
      return globalThis.requestIdleCallback(callback, { timeout })
    }
    return setTimeout(callback, 0)
  }

  function drain() {
    if (draining || queue.length === 0) return
    draining = true
    schedule(() => {
      draining = false
      const task = queue.shift()
      task()
      drain()
    })
  }

  return {
    enqueue(task) {
      queue.push(task)
      drain()
    },
  }
}
